type StaffGivingStatementPdfModule = typeof import("@/lib/staff-giving-statement-pdf");
type VolunteerCertificatePdfModule = typeof import("@/lib/volunteer-certificate-pdf");
type BifoldBulletinPdfModule = typeof import("@/lib/bifold-bulletin-pdf");

let staffGivingStatementPdfModule: Promise<StaffGivingStatementPdfModule> | null = null;
let volunteerCertificatePdfModule: Promise<VolunteerCertificatePdfModule> | null = null;
let bifoldBulletinPdfModule: Promise<BifoldBulletinPdfModule> | null = null;

export const loadStaffGivingStatementPdf = (): Promise<StaffGivingStatementPdfModule> => {
  if (!staffGivingStatementPdfModule) {
    staffGivingStatementPdfModule = import("@/lib/staff-giving-statement-pdf").catch((error) => {
      staffGivingStatementPdfModule = null;
      throw error;
    });
  }

  return staffGivingStatementPdfModule;
};

export const loadVolunteerCertificatePdf = (): Promise<VolunteerCertificatePdfModule> => {
  if (!volunteerCertificatePdfModule) {
    volunteerCertificatePdfModule = import("@/lib/volunteer-certificate-pdf").catch((error) => {
      volunteerCertificatePdfModule = null;
      throw error;
    });
  }

  return volunteerCertificatePdfModule;
};

export const loadBifoldBulletinPdf = (): Promise<BifoldBulletinPdfModule> => {
  if (!bifoldBulletinPdfModule) {
    bifoldBulletinPdfModule = import("@/lib/bifold-bulletin-pdf").catch((error) => {
      bifoldBulletinPdfModule = null;
      throw error;
    });
  }

  return bifoldBulletinPdfModule;
};
